import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import OtpTimer from "otp-timer";
import { useFormContext } from "../../../context/Context";
import api from '../../../services/api';
import axiosPublic from '../../../services/axios/axiosPublic';
import { saveData } from '../../../redux/formActions';
import { useDispatch } from 'react-redux';
import { useForm } from 'react-hook-form';

export default function EnterOtp() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const {
        register, handleSubmit, reset, formState: { errors }, setValue
    } = useForm();
    const { serverError, setServerError } = useFormContext();
    const [retrievedEmail, setRetrievedEmail] = useState('');
    const [otpValues, setOtpValues] = useState(new Array(6).fill('')); // Array to hold OTP values
    const otpRefs = useRef([]);
    const [, setIsOtpResend] = useState(false);
    const otpRequestedRef = useRef(false);

    const handleError = () => {
        setServerError("Please enter all required OTP fields correctly");
    };
    useEffect(() => {
        const email = localStorage.getItem('emailForOtpValidation');
        setRetrievedEmail(email);
    }, []);

    useEffect(() => {
        // Sync local state with React Hook Form whenever the watched values change
        otpValues.forEach((value, index) => {
            setValue(`otp${index}`, value);
        });
    }, [otpValues, setValue]);

    // Focus the first OTP input on component load
    useEffect(() => {
        if (otpRefs.current[0]) {
            otpRefs.current[0].focus();
        }
    }, []);

    // Track render count
    const renderCount = useRef(0);
    renderCount.current += 1;
    const handleOtpChange = (index, value) => {
        console.log("Input changed:", value);
        setServerError('');
        // Ensure the input is a valid digit and not empty, with a maximum length of 1
        if (/^\d*$/.test(value) && value.length <= 1) {
            const newOtpValues = [...otpValues];
            newOtpValues[index] = value;
            setOtpValues(newOtpValues);
            if (value && index < otpRefs.current.length - 1) {
                otpRefs.current[index + 1]?.focus();
            }
            // Move focus to the previous input if the value is deleted and it's not the first input
            else if (!value && index > 0) {
                otpRefs.current[index - 1]?.focus();
            }
        }
        if (!value) {
            otpRefs.current[index]?.focus();
        }
    };

    const handleKeyDown = (e, index) => {
        if (e.key === 'Backspace' && !otpValues[index]) {
            // Move to the previous input only if the current input is empty
            if (index > 0) {
                otpRefs.current[index - 1]?.focus();
            }
        }
    };

    const handleResendOtp = async () => {
        try {
            otpRequestedRef.current = false;
            const formData = new URLSearchParams();
            formData.append('email', retrievedEmail);
            const response = await axiosPublic.post(api.resendOtp, formData, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
            });
            if (response?.data?.success === true) {
                setOtpValues(new Array(6).fill(''));
                setIsOtpResend(true);
                toast.success(response?.data?.reason || "A fresh otp has been sent to your email id.", { className: 'toast-success-custom' });
                reset();
            } else {
                toast.error(response?.data?.reason || "Failed to resend OTP. Please go back and verify your email.", { className: 'toast-error-custom', autoClose: 8000 });
            }
        } catch (error) {
            toast.error(error?.message || "Unable to connect to the server.", { className: 'toast-error-custom', autoClose: 8000 });
        }
    };

    const handleFormSubmit = async () => {
        const combinedOtp = otpValues.join('');
        const formData = new URLSearchParams();
        formData.append('email', retrievedEmail);
        formData.append('otp', combinedOtp);

        if (combinedOtp.length === 6) {
            try {
                const otpResult = await axiosPublic.post(api.validateOtp, formData, {
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                    }
                })
                if (otpResult?.data?.success === true) {
                    const Data = {
                        id: otpResult.data.data.userId,
                        fullName: otpResult.data.data.fullName,
                        firstName: otpResult.data.data.firstName,
                        lastName: otpResult.data.data.lastName,
                        middleName: otpResult.data.data.middleName,
                        email: otpResult.data.data.email,
                    };               
                    const isCompleted= otpResult.data.data.documentUploadStatus === 'COMPLETED'?true:false;
                    const isPending=otpResult.data.data.documentUploadStatus === 'PENDING'?true:false;
                    const isPartialCompleted=otpResult.data.data.documentUploadStatus === 'PARTIAL_COMPLETED'?true:false;
                    const isBackForRevision=otpResult.data.data.documentUploadStatus === 'SENT_BACK_FOR_REVISION'?true:false;
                    localStorage.setItem("token", otpResult.data.data.token);
                    dispatch(saveData(Data));
                    toast.success(otpResult?.data?.reason || "otp has been verified successfully!", { className: 'toast-success-custom' });
                    reset();
                    setOtpValues(new Array(6).fill(''));
                    setIsOtpResend(false);
                    localStorage.removeItem('emailForOtpValidation');
                    setTimeout(() => {
                    if(isCompleted){
                        navigate('/preonboarding-forms/success', { replace: true })
                    }else if(isPending){
                         navigate('/preonboarding-forms', { replace: true })
                    }else if(isPartialCompleted){
                        navigate('/preonboarding-forms', { replace: true })
                    }else if(isBackForRevision){
                        navigate('/preonboarding-forms', { replace: true })
                    }else{
                         navigate('/email-verification', { replace: true })
                    }
                       
                    }, 1000);
                } else {
                    toast.error(otpResult?.data?.reason || "Invalid OTP. Please try again.", { className: 'toast-error-custom', autoClose: 8000 });
                }
            } catch (err) {
                toast.error(err?.message || "Unable to connect to the server.", { className: 'toast-error-custom', autoClose: 8000 });
            }
        }
        else {
            toast.error(otpResult?.data?.reason || "Please enter a valid 6-digit OTP", { className: 'toast-error-custom', autoClose: 8000 });
        }
    };

    return (
        <div className="container-fluid candidate-authentication">
            <div className='main-logo'>
                <div className="logo-image">
                    <img src={require("assets/img/company_logo.png")} alt="..." />
                </div>
            </div>
            <div className="login-container">
               <div className="row enterotp-row">
                 <div className="col-lg-12 col-md-10 col-sm-8 col-xs-12 left">
                    <div className="login-form">                        
                        <div className="form">
                            <form onSubmit={handleSubmit(handleFormSubmit, handleError)}>
                                <p className="enterotp-title">ENTER OTP</p>
                                <p className='otpDirection'>otp was sent to your email id</p>
                                <div className="form-detail">
                                    <div className="input-text">
                                        <div className="otp-container">
                                            {otpValues.map((_, index) => (
                                                <input key={`otp-input-${index}`} type="text" maxLength="1" value={otpValues[index]}
                                                    className={`otp-input ${errors[`otp${index}`] ? 'error' : ''}`}
                                                    {...register(`otp${index}`, {
                                                        required: 'true',
                                                        pattern: {
                                                            value: /^\d$/,
                                                            message: 'Must be a single digit'
                                                        }
                                                    })}
                                                    onChange={(e) => handleOtpChange(index, e.target.value)}
                                                    ref={(el) => (otpRefs.current[index] = el)}
                                                    onKeyDown={(e) => handleKeyDown(e, index)}
                                                />
                                            ))}
                                        </div>
                                    </div>
                                    <div>
                                        <div>
                                            <button className="login" type="submit"> verify
                                            </button>
                                        </div>
                                    </div>
                                    <div className="text">
                                        <OtpTimer
                                            minutes={5}
                                            seconds={1}
                                            text="Resend otp in"
                                            ButtonText="Resend OTP"
                                            resend={handleResendOtp}
                                        />
                                    </div>
                                    {serverError && (<div style={{ fontSize: '13px', color: 'red' }}>{serverError}</div>)}
                                </div>
                            </form>
                        </div>
                        <ToastContainer />
                    </div>
                </div>
               </div>
            </div>
        </div>
    )
}

